<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">TIPs Data</h2>
      <p class="tw-italic tw-text-gray-700">
        View TIPs Data
      </p>
    </b-container>
    <br />

    <b-row>
      <b-col cols="4">
        <b-form-group
            id="fieldset-1"
            label="Date"
            label-for="search_date"
        >
            <b-form-datepicker
                id="search_date"
                v-model="filterDate"
                placeholder="Date"
                class="mb-2"
            >
            </b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group
          id="fieldset-1"
          label="Compound"
          label-for="filterCompound"
        >
          <b-form-select id="filterCompound" v-model="filterCompound" :options="compoundOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group
          id="visitid"
          label="Visit"
          label-for="readercodeoptions"
        ><b-form-select id="visitTimeOptions" v-model="filterVisitTime" :options="visitTimeOptions"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <small>Total Results: {{ totalRows }} <i @click="downloadFile" class="fa fa-download text-success" v-b-modal.report-modal style="margin-left: 10px; cursor: pointer;" title="Download All"></i></small>
      </b-col>
    </b-row>

    <div style="width: 100%; overflow: auto;">
      <b-table
        striped
        hover
        :items="find"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        ref="resultTable"
        @row-clicked="rowClick"
        :tbody-tr-class="'clickable'"
      >
      </b-table>
    </div>

    <b-row>
      <b-col cols="2">
        <b-form-group id="fieldset-2" label="Results Per Page" label-for="input-2">
          <b-form-select id="input-2" v-model="perPage" :options="perPageOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col class="my-1" cols="9" style="padding-top: 30px;">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import { each } from 'lodash';

const studyName = process.env.VUE_APP_STUDY;

export default {
  mixins: [
    // BaseTemplate,
    DashboardBaseTemplate,
  ],
  components: {},
  props: {},
  data: function() {
    return {
        sortBy: 'id',  // TODO: MAKE SURE THIS IS A GOOD DEFAULT SORT
        sortDesc: true,
        tableData: [],
        title: "",
        totalRows: 1,
        currentPage: 1,
        perPage: 20,
        perPageOptions: [
            10,
            15,
            20,
            25,
            50
        ],
        filterDate: '',
        filterCompound: 'All',
        filterVisitTime: 'All',
        compoundOptions : [
            'All',
        ],
        visitTimeOptions: [
            {value: 'All', text: 'All'},
            {value: '1_wk', text: '1 Week'},
            {value: '2_mo', text: '2 Month'},
            {value: '6_mo', text: '6 Month'},
            {value: '12_mo', text: '12 Month'},
            {value: '18_mo', text: '18 Month'},
            {value: '24_mo', text: '24 Month'}
        ],
    };  },
  computed: {},
  watch: {
    filterDate: function(){
      this.updateTable();
    },
    filterCompound: function(){
      this.updateTable();
    },
    filterVisitTime: function(){
      this.updateTable();
    },
  },
  created: function() {
    this.setUpFields(this.$route.params.view);
  },
  mounted: function() {
    let that = this;
    // load the visit code and village drop-down options
    HTTP.get('/' + (studyName != null ? studyName : 'kenya') + '/tips-drop-down-options')
      .then((response) => {
          each(response.data.compounds, function(item){
          that.compoundOptions.push(item);
        });
      })
      .catch((error) => {
        HandleErrors.HandleErrors(error);
      })
  },
  methods: {
    // downloadFile: function(){
    //   HTTP.get('/kenya/download_tips_data').then(response => {
    //       var fileURL = window.URL.createObjectURL(
    //           new Blob([response.data])
    //       );
    //       var fileLink = document.createElement("a");
    //       fileLink.href = fileURL;
    //       // const today = new Date();
    //       // fileLink.setAttribute("download", "TIPsData-" + today + ".csv");
    //       fileLink.setAttribute("download", "TIPsData.csv");
    //       document.body.appendChild(fileLink);
    //       fileLink.click();
    //   });
    // },
    downloadFile: function(){
      let params = {
        return_as: 'csv',
      }
      HTTP.get('/' + (studyName != null ? studyName : 'kenya') + '/tips-data', {params: params}).then(response => {
          var fileURL = window.URL.createObjectURL(
              new Blob([response.data])
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          // const today = new Date();
          // fileLink.setAttribute("download", "TIPsData-" + today + ".csv");
          fileLink.setAttribute("download", "TIPsData.csv");
          document.body.appendChild(fileLink);
          fileLink.click();
      });
    },
    updateTable: function(){
      this.$refs.resultTable.refresh();
    },
    printTable: function(){
      let table_id = this.$refs.resultTable.localId_;
      var divToPrint=document.getElementById(table_id);
      var newWin = window.open("");
      var html_to_print = divToPrint.outerHTML.replaceAll(' (Click to clear sorting)', '').replaceAll(' (Click to sort Ascending)', '');
      var all_html = '<html><head>\
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" integrity="undefined" crossorigin="anonymous">\
      <body>\
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" integrity="undefined" crossorigin="anonymous">\
      '+html_to_print+'<style>\
      </style>\
      </body></html>';
      // get the stylesheet
      newWin.document.write(all_html);
      newWin.document.close();
      var myDelay = setInterval(checkReadyState, 10);
      function checkReadyState() {
          if (newWin.document.readyState == "complete") {
              clearInterval(myDelay);
              newWin.focus(); // necessary for IE >= 10

              newWin.print();
              newWin.close();
          }
      }
    },
    rowClick: function(item){
      let that = this;
      that.selectedMicroscopy = item;
      console.log(item);
    },
    find: function(ctx) {
      let that = this;
      let params = {
        current_page: ctx.currentPage,
        per_page: ctx.perPage,
        sort_by: ctx.sortBy,
        sort_desc: ctx.sortDesc
      }

      if(that.filterDate && that.filterDate != ''){
        params.filterDate = that.filterDate;
      }
      if(that.filterCompound != 'All'){
        params.filterCompound = that.filterCompound;
      }
      if(that.filterVisitTime != 'All'){
        params.filterVisitTime = that.filterVisitTime;
      }

      return HTTP.get('/' + (studyName != null ? studyName : 'kenya') + '/tips-data', {
        params: params
      })
        .then((response) => {
          that.tableData = response.data.row_data;
          that.totalRows = response.data.totalRows;
          return that.tableData;
        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    setUpFields: function(view) {
      if (view == "details") {
        this.title = "Details";
        this.fields = [
        //   { key: "bloodslide_code", label: "Bloodslide Code" },
        ];
      } else {
        this.title = "Summary";
        this.fields = studyName != null && studyName === 'srilanka'
          ? [
              // for srilanka, set up key and label manually to use custom table headers
              { key: 'field_worker', label: 'RA Initials' },
              { key: 'tips_visit_date', label: 'Visit Date' },
              { key: 'compound_id_pull', label: 'HH ID' },
              { key: 'individual_id', label: 'Individual ID' },
              { key: 'tips_observation_complete', label: 'Observation Complete' },
              { key: 'able_to_observe', label: 'Able To Observe' },
              { key: 'reason_not_observed', label: 'Reason Not Able To Observe' },
              { key: 'revisit_compound_tips', label: 'Revisit HH' },
              { key: 'tips_observation_start_time', label: 'Start Time' },
              { key: 'tips_observation_end_time', label: 'End Time' },
              { key: 'visit', label: 'Visit' },
              { key: 'tips_collection_code', label: 'TIPs Collection Code' },
              { key: 'other_features_dengue_exposure', label: 'Observation On Exposure to Mosquito or Dengue' },
              { key: 'other_observations', label: 'Other Observations' },
              { key: 'number_of_rooms', label: '# of Rooms Observed' },
              { key: 'products_last_placed_on', label: 'Products Last Placed On' },
              { key: 'products_required', label: 'HH Products Required' },
              { key: 'room_observation_list', label: 'Room List' },
              { key: 'room_loop_position', label: 'Room Observed #' },
              { key: 'room_observed', label: 'Room ID' },
              { key: 'room_observed_select', label: 'Room Description' },
              { key: 'room_products_required', label: 'Room Products Required' },
              { key: 'products_installed_actual', label: 'Room Products Installed' },
              { key: 'products_hanging', label: 'Room Products Hanging' },
              { key: 'products_not_hanging_visible', label: 'Room Products Visible but Not Hanging' },
              { key: 'products_not_hanging_not_visible', label: 'Room Products Not Visible or Hanging' },
              { key: 'product_location_notes', label: 'Comments On Products in Room' },
              { key: 'hooks_installed', label: 'Products Installed - Hooks Only' },
              { key: 'hooks_remaining', label: 'Products Installed - Hooks Only - Remaining' },
              { key: 'hooks_missing', label: 'Products Installed - Hooks Only - Missing' },
              { key: 'hooks_notes', label: 'Products Installed - Hooks Only - Notes' },
              { key: 'hooks_and_tape_installed', label: 'Products Installed - Hooks and Tape' },
              { key: 'hooks_with_tape_remaining', label: 'Products Installed - Hooks and Tape - Hooks Remaining' },
              { key: 'hooks_with_tape_missing', label: 'Products Installed - Hooks and Tape - Hooks Missing' },
              { key: 'tape_remaining', label: 'Products Installed - Hooks and Tape - Tape Remaining' },
              { key: 'tape_missing', label: 'Products Installed - Hooks and Tape - Tape Missing' },
              { key: 'tape_notes', label: 'Products Installed - Hooks and Tape - Notes' },
              { key: 'other_fastener_installed', label: 'Products Installed - Other Fasteners' },
              { key: 'other_fastener_specify', label: 'Products Installed - Other Fasteners - Description' },
              { key: 'other_fastener_remaining', label: 'Products Installed - Other Fasteners - Remaining' },
              { key: 'other_fastener_missing', label: 'Products Installed - Other Fasteners - Missing' },
              { key: 'other_fastener_notes', label: 'Products Installed - Other Fasteners - Notes' },
              { key: 'products_intact', label: 'Room Products Intact' },
              { key: 'products_worn', label: 'Room Products Worn' },
              { key: 'products_extremely_worn', label: 'Room Products Extremely Worn' },
              { key: 'product_appearance_notes', label: 'Room Products Appearance Notes' },
              { key: 'products_not_handled', label: 'Room Products Not Handled' },
              { key: 'products_handled', label: 'Room Products Handled' },
              { key: 'handling_signs_description', label: 'Room Products Handling Notes' },
              { key: 'other_room_observations', label: 'Room Observations' },
              { key: 'pictures_associated', label: 'Room Photos Taken' },
              { key: 'pictures_needed_to_take', label: '# Photos Taken' }
            ]
        : [
            // { key: "bloodslide_code", label: "Bloodslide Code", sortable: true },
          ];
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.setUpFields(to.params.view);
    next();
  }
};
</script>

<style scoped>
.clickable{
  cursor: pointer;
}
</style>
